<template>
  <th
    :class="sortClass"
    @click="!state.hideSortIcons && !hideCustomSortIcon ? sort() : ''"
  >
    <slot></slot>
    <template v-if="!state.hideSortIcons && !hideCustomSortIcon">
      <slot name="ascIcon" v-if="order === -1">
        <span>
          <svg
            width="16"
            height="16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            style="margin-bottom: -7px; display: inline-block; vertical-align: inherit;"
          >
            <path
              fill="#4d48e8"
              d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
            ></path>
          </svg>
        </span>
      </slot>
      <slot name="sortIcon" v-else-if="order === 0">
        <span>
          <svg
            class="mt-xxs"
            width="16"
            height="16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            style="margin-bottom: -3px; display: inline-block; vertical-align: inherit;"
          >
            <path
              fill="#4d48e8"
              d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
            ></path>
          </svg>
        </span>
      </slot>
      <slot name="descIcon" v-else-if="order === 1">
        <span>
          <svg
            width="16"
            height="16"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            style="margin-bottom: -1px; display: inline-block; vertical-align: inherit; "
          >
            <path
              fill="#4d48e8"
              d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
            ></path>
          </svg>
        </span>
      </slot>
    </template>
  </th>
</template>

<script>
export default {
  name: 'v-th',
  props: {
    id: {
      required: false,
      type: String,
      default: '',
    },
    sortKey: {
      required: false,
      type: [String, Function],
    },
    customSort: {
      required: false,
      type: Function,
    },
    defaultSort: {
      required: false,
      type: String,
      validator: value => ['asc', 'desc'].includes(value),
    },
    hideCustomSortIcon: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  inject: ['store'],
  data() {
    return {
      order: 0,
      orderClasses: ['vt-desc', 'vt-sortable', 'vt-asc'],
      state: this.store._data,
    };
  },
  computed: {
    sortEnabled() {
      return this.sortKey || typeof this.customSort === 'function';
    },
    sortClass() {
      const className = this.state.hideSortIcons
        ? [this.orderClasses[this.$store.state.sort.order + 1], 'vt-sort']
        : [];

      if (!this.state.hideSortIcons && !this.hideCustomSortIcon) {
        className.push('cursor-pointer');
      }
      return className;
    },
  },
  mounted() {
    if (!this.sortKey && !this.customSort) {
      throw new Error(
        'Must provide the Sort Key value or a Custom Sort function.'
      );
    }
    this.store.setSort({
      sortKey: this.$store.state.sort.key,
      sortOrder: this.$store.state.sort.order,
    });
    if (this.sortKey === this.$store.state.sort.key) {
      this.order = this.$store.state.sort.order;
    }
  },
  methods: {
    sort: function() {
      if (this.sortEnabled) {
        let order =
          this.$store.state.sort.order === 0 ||
          this.$store.state.sort.order === -1
            ? this.$store.state.sort.order + 1
            : -1;
        this.$store.commit('setSort', {
          key: this.sortKey,
          order: order,
          id: this.id,
        });
        this.store.setSort({
          sortKey: this.sortKey,
          customSort: this.customSort,
          sortOrder: this.order,
          sortId: this.id,
        });
        this.order = this.$store.state.sort.order;
        if (order === -1) {
          this.$emit('sortChange', '-' + this.sortConvert(this.sortKey));
        } else if (order === 1) {
          this.$emit('sortChange', this.sortConvert(this.sortKey));
        } else if (order === 0) {
          this.$emit('sortChange', '');
        }
      }
    },
    sortConvert(key) {
      if (key === 'tierName') {
        return 'tier_name';
      }
      if (key === 'agencyName') {
        return 'agency_name';
      }
      if (key === 'companyName') {
        return 'company_name';
      }
      if (key === 'resellerName') {
        return 'directory_entry__reseller__name';
      }
      if (key === 'vendorName') {
        return 'vendor_name';
      }
      if (key === 'date') {
        return 'created';
      }
      if (key === 'lead') {
        return 'status';
      }
      if (key === 'projectStatus') {
        return 'project_status';
      }
      return key;
    },
  },
};
</script>

<style scoped>
.vt-sort {
  cursor: pointer;
}
</style>
